import React from "react";
import {Dialog, Button, Typography} from "@material-ui/core";
import {Cancel, CheckCircle} from "@material-ui/icons";



interface IProps {
    open: boolean
    message: string
    cancelled(): void
    accepted(): void
}

interface IState {
}

class Confirmacion extends React.Component<IProps, IState>{

    state:IState = {
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        overflow: "hidden"
                    }
                }}
                maxWidth={"lg"}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <Typography
                    style={{
                        marginTop: 40,
                        marginLeft: 30,
                        marginRight: 30,
                        fontFamily: "Poppins",
                        fontSize: 16
                    }}
                >
                    {this.props.message}
                </Typography>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: "100%",
                        justifyContent: "space-around",
                        marginBottom: 20,
                        marginTop: 40
                    }}
                >
                    <Button
                        onClick={() => this.props.accepted()}
                    >
                        <CheckCircle
                            style={{
                                height: 40,
                                width: 40,
                                color: "#4c9938"
                            }}
                        />
                    </Button>
                    <Button
                        onClick={() => this.props.cancelled()}
                    >
                        <Cancel
                            style={{
                                height: 40,
                                width: 40,
                                color: "#bb1e1e"
                            }}
                        />
                    </Button>
                </div>
            </Dialog>
        )
    }
}


export default Confirmacion;
